<template lang="pug">
  #program-customization
    WtTile(ancestor vertical)
      WtTile(parent)
        ProgramCustomizationNavigator
      WtTile
        WtTile(parent :col="12")
          WtTile(child :col="12")
            BTabs.block(v-model="activeTab" positioned="is-centered" @input="updateRoute(activeTab)" size="is-medium")
              BTabItem(v-for="tab in tabs" :key="tab.label" :label="tab.label")
            RouterView
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import ProgramCustomizationNavigator from "@@/ProgramCustomization/ProgramCustomizationNavigator";
import { mapGetters } from "vuex";
import { tabsMixin } from "@/mixins/tabsMixin";

export default {
  name: "ProgramCustomization",

  components: { ProgramCustomizationNavigator, WtTile },

  mixins: [tabsMixin],

  computed: {
    ...mapGetters("authMember", ["isWtAdmin"]),
    ...mapGetters("program", ["isCoreTier"]),

    tabs() {
      return [
        {
          label: "Nav Bar Button",
          routeName: "ProgramCustomizationNavbar"
        },
        {
          label: "Custom Login",
          routeName: "ProgramCustomizationLogin"
        }
      ];
    }
  }
};
</script>
